import React, { useState } from 'react';

import { Radios } from '../../../components';

import classes from './SelectedRol.module.scss';
import { ReactComponent as LightUsers } from '../../../assets/icons/LightUsers.svg';

const optionsRols = [
    {
        key: 'business',
        label: 'Empresa'
    },
    {
        key: 'independent',
        label: 'Independiente'
    },
    {
        key: 'admincoowner',
        label: 'Administrador copropiedad'
    },
    {
        key: 'owner',
        label: 'Propietario'
    },
    {
        key: 'tenant',
        label: 'Arrendatario'
    },
    {
        key: 'other',
        label: 'Otro'
    },
];

const SelectedRol = ({setFieldValue, rol}) => {

    const onChange = (newValue) => {
        setFieldValue('rol', newValue);
    }

  return (
    <div className={classes.content}>
        <LightUsers/>
        <span className={`bold-20 ${classes.subtitle}`}>Elige tu perfil</span>
        <span className={`medium-16 ${classes.description}`}>
            Selecciona el perfil que mejor se adapte a ti.
        </span>
        <Radios className={classes.options} value={rol} options={optionsRols} onChange={newValue => onChange(newValue)} />
    </div>
  )
}

export default SelectedRol